<i class="fas fa-star default-indicator"
   [ngStyle]="{display: !isDefault ? 'none': 'inline'}"
   (click)="setAsDefault()"
   [matTooltip]="isDefault ? 'Default': 'Set as default'"
   matTooltipPosition="right"
   matTooltipClass="text-center"></i>
